<template>
  <Modal :id="id" title="选择目录" size="tiny" @ok="ok">
    <DirectoryTree ref="dirTree" @change="value = $event"
      :root='root' :default='root' />
  </Modal>
</template>

<script>
import Modal from './modal.vue'
import DirectoryTree from './directory-tree.vue'

export default {
  name: 'DirSelectModal',
  props: ['id'],
  components: {
    DirectoryTree,
    Modal,
  },
  data: function () {
    return {
      value: null,
      on_ok: null,
    };
  },
  computed: {
    root() {
      return this.$store.state.space.root;
    },
  },
  methods: {
    ok() {
      if (this.on_ok) {
        this.on_ok(this.value.path);
      } else {
        this.$emit("ok", this.value.path);
      }
    },
    reset() {
      this.$refs.dirTree.reset();
    },
    show(on_ok) {
      this.show_modal(this.id);
      this.on_ok = on_ok;
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>
